import React from 'react';

import Image from '../../library/image/image';
import Flag from '../flag/flag';

import './treadwell-rank-banner.scss';

interface TreadwellRankBannerProps {
  className?: string;
  hideLabel?: boolean;
  rank?: number;
}

function TreadwellRankBanner(props: TreadwellRankBannerProps) {
  const { className = '', hideLabel = false, rank } = props;
  return (
    <span className={`treadwell-rank-banner ${className}`}>
      <Flag styleName="tw-rank">
        #{rank}
        {hideLabel && (
          <Image
            alt="Treadwell icon"
            height="22"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/treadwell-icon-only-trademark-on-white.svg"
            styleName="icon"
          />
        )}
      </Flag>
      {!hideLabel && (
        <Flag
          renderIcon={
            <Image
              alt="Treadwell icon"
              height="22"
              src="https://discounttire.scene7.com/is/content/discounttire/logos/treadwell-icon-only-trademark-on-white.svg"
            />
          }
          styleName="tw-text-flag"
        >
          {rank === 1 ? 'BEST MATCH' : 'RECOMMENDED'}
        </Flag>
      )}
    </span>
  );
}

export default TreadwellRankBanner;
